import { Create, Edit, List } from "../Components/index.js";

export default [
    {
        path: "/bq-store/ration/users",
        component: List,
        name: "bq-store-ration-users",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/bq-store/ration/others",
        component: () => import("../Components/Others.vue"),
        name: "bq-store-ration-others",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/bq-store/ration/user/create",
        component: Create,
        name: "bq-store-ration-user-add",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/bq-store/ration/user/:user_id/edit",
        component: Edit,
        name: "bq-store-ration-user-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/bq-store/ration/other-user/:id/edit",
        component: () => import("../Components/OtherEdit.vue"),
        name: "bq-store-ration-other-user-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
